import Vue from 'vue';

import './attendant-session';
import './basket';
import './best-seller';
import './bir-reports';
import './daily-sales';
import './drawer-check';
import './drawersession';
import './fuel';
import './fuel-sales-by-tank';
import './fuel-transaction';
import './ghl-reimbursement';
import './hourly';
import './loyalty-category';
import './new-cancelled-order';
import './payment';
import './price-override';
import './profit';
import './promotion';
import './pump-test';
import './reimbursement';
import './sales-category';
import './sales-mix';
import './shell-app-reimbursement';
import './shell-app-voucher-promotion';
import './shell-reimbursement';
import './subsidy-reimbursement';
import './tax';
import './tng-rfid-reimbursement';
import './tng-subsidy-reimbursement';
import './virtual-shift';

Vue.component('cash-adjustment-report', () =>
    import(/* webpackChunkName: 'report' */ './cash-adjustment/cash-adjustment.vue'),
);

Vue.component('cash-flow-report', () =>
    import(/* webpackChunkName: 'report' */ './daily-sales/cash-flow-report.vue'),
);

Vue.component('staff-attendance', () =>
    import(/* webpackChunkName: 'report' */ './staff-attendance/staff-attendance-list.vue'),
);
